import popNotice from '../../app/main/message/views/pop-notice.html';
import noticePage from '../../views/common/notice.html';
class messageService {
  constructor(
    $http,
    $location,
    $q,
    logger,
    httpRequest,
    $rootScope,
    $state,
    $uibModal,
    $sce
  ) {
    this.$http = $http;
    this.$location = $location;
    this.$q = $q;
    this.logger = logger;
    this.httpRequest = httpRequest;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.$sce = $sce;
  }

  // NOTE: 查询消息中心中未读消息
  fetchMessageCenter() {
    this.fetchMessageList();
    this.fetchMessageTotal();
  }

  fetchMessageTotal() {
    this.httpRequest.fetchMessageTotal().then((res) => {
      if (res && res.data && res.data.success) {
        this.$rootScope.noReadMessage =
          res.data.value && res.data.value.noReadTotal;
      }
    });
  }

  fetchMessageList() {
    this.httpRequest
      .fetchMessageList({
        param: {
          instanceStatus: '0',
        },
        pageSize: 5,
        pageNum: 1,
      })
      .then((res) => {
        if (res && res.data && res.data.success) {
          this.$rootScope.messageList = res.data.value && res.data.value.list;
        }
      });
  }

  // NOTE: 是否显示功能包到期提示
  openShowList() {
    let _this = this;
    this.httpRequest.fetchPopNotice().then((res) => {
      if (res && res.data && res.data.success) {
        //  登录进来再缓存机构信息 解决登录时缓存卡死现象
        const userInfo = JSON.parse(localStorage.getItem('user_info'));
        localStorage.removeItem('user_info');
        userInfo.orgList = this.$rootScope.loginOrgList || userInfo.orgList;
        localStorage.setItem('user_info', JSON.stringify(userInfo));
        console.log('显示功能包缓存用户信息');
        let noPopNoticeList = window.sessionStorage.getItem('noPopNoticeList');
        noPopNoticeList = noPopNoticeList ? JSON.parse(noPopNoticeList) : [];
        this.$rootScope.popNoticeList =
          res.data.value && res.data.value['1'] && res.data.value['1'].length
            ? res.data.value['1']
            : [];
        let popNoticeList = [];
        if (this.$rootScope.popNoticeList.length && noPopNoticeList.length) {
          popNoticeList = this.$rootScope.popNoticeList.filter(
            // item => noPopNoticeList.findIndex(id => id === item.noticeId) === -1
            (item) => {
              let flag = false;
              noPopNoticeList.forEach((id) => {
                if (id === item.noticeId) {
                  flag = flag || true;
                }
              });
              return !flag;
            }
          );
        } else {
          popNoticeList = this.$rootScope.popNoticeList;
        }
        popNoticeList.forEach((item, index) => {
          if (!$('#wrapper').hasClass('invoiceDetailPage')) {
            const clientWidth = $(window).width();
            const popWidth = 360;
            const positionTop = `${100 - index * 5}px`,
              positionLeft = `${clientWidth - popWidth - index * 5}px`;
            const layerTitle = `<i class="fa fa-envelope-o"></i><span style="padding-left:5px">${
              item.messageType === '1' ? '新用户消息' : '系统消息'
            }</span>`;

            function hideModal(index) {
              window.layer.close(index);
              let noPopNoticeList =
                window.sessionStorage.getItem('noPopNoticeList');
              noPopNoticeList = noPopNoticeList
                ? JSON.parse(noPopNoticeList)
                : [];
              const noPopNoticeSet = new Set(noPopNoticeList);
              noPopNoticeSet.add(item.noticeId);
              window.sessionStorage.setItem(
                'noPopNoticeList',
                JSON.stringify(Array.from(noPopNoticeSet))
              );
            }
            function neverMind(index) {
              _this.httpRequest
                .updateMessageNeverMind({ noticeIds: [item.noticeId] })
                .then((res) => {
                  if (res && res.data && res.data.success) {
                    window.layer.close(index);
                  }
                });
            }

            window.layer.open({
              type: 1,
              title: layerTitle,
              content: item.noticeTitle,
              btn: ['查看', '本次忽略', '不再提醒'],
              skin: 'layer-system-message-window',
              shade: 0,
              resize: false,
              area: [popWidth + 'px', '130px'],
              offset: [positionTop, positionLeft],
              // move: false,
              tipsMore: true,

              yes(index) {
                _this.$state.go('message.detail', { noticeId: item.noticeId });
                window.layer.closeAll('page');
              },
              btn2: function (index) {
                console.log('本次忽略');
                hideModal(index);
              },
              btn3: function (index) {
                console.log('不再提醒');
                neverMind(index);
              },
              cancel: function (index) {
                console.log('直接关闭');
                hideModal(index);
              },
            });
          }
        });

        if (
          res.data.value &&
          res.data.value['2'] &&
          res.data.value['2'].length
        ) {
          const noticeWindowParamList = res.data.value['2'].slice();
          _this.$uibModal.open({
            template: noticePage,
            openedClass: 'mod-modal mod-modal-hg',
            controller: [
              '$scope',
              'message',
              '$sce',
              '$uibModalInstance',
              'httpRequest',
              ($scope, message, $sce, $uibModalInstance, httpRequest) => {
                let noticeWindowParamIndex = 0;
                $scope.btn1Disable = noticeWindowParamList.length === 1;
                $scope.btn2Disable = noticeWindowParamList.length === 1;
                $scope.message = noticeWindowParamList[noticeWindowParamIndex];
                $scope.messageContent = $sce.trustAsHtml(
                  noticeWindowParamList[noticeWindowParamIndex].noticeContent
                );
                _this.httpRequest.setMessageReaded({
                  noticeIds: [
                    noticeWindowParamList[noticeWindowParamIndex].noticeId,
                  ],
                });
                noticeWindowParamList[noticeWindowParamIndex].$$isread = true;

                $scope.btn1 = function btn1() {
                  noticeWindowParamIndex--;
                  $scope.btn2Disable = false;
                  $scope.message =
                    noticeWindowParamList[noticeWindowParamIndex];
                  $scope.messageContent = $sce.trustAsHtml(
                    noticeWindowParamList[noticeWindowParamIndex].noticeContent
                  );
                  if (noticeWindowParamIndex === 0) {
                    $scope.btn1Disable = true;
                  }
                };
                $scope.btn2 = function btn2() {
                  noticeWindowParamIndex++;
                  if (!noticeWindowParamList[noticeWindowParamIndex].$$isread) {
                    _this.httpRequest.setMessageReaded({
                      noticeIds: [
                        noticeWindowParamList[noticeWindowParamIndex].noticeId,
                      ],
                    });
                    noticeWindowParamList[
                      noticeWindowParamIndex
                    ].$$isread = true;
                  }
                  $scope.btn1Disable = false;
                  $scope.message =
                    noticeWindowParamList[noticeWindowParamIndex];
                  $scope.messageContent = $sce.trustAsHtml(
                    noticeWindowParamList[noticeWindowParamIndex].noticeContent
                  );
                  if (
                    noticeWindowParamIndex ===
                    noticeWindowParamList.length - 1
                  ) {
                    $scope.btn2Disable = true;
                  }
                };
                $scope.btn3 = function btn3() {
                  const noticeIds = noticeWindowParamList.map(
                    (item) => item.noticeId
                  );
                  httpRequest
                    .updateMessageNeverMind({ noticeIds })
                    .then((res) => {
                      if (res && res.data && res.data.success) {
                        $uibModalInstance.dismiss();
                      }
                    });
                };
              },
            ],
            animation: true,
            resolve: {
              message() {
                return noticeWindowParamList;
              },
            },
          });
        }
      }
    });
  }
}
messageService.$inject = [
  '$http',
  '$location',
  '$q',
  'logger',
  'httpRequest',
  '$rootScope',
  '$state',
  '$uibModal',
  '$sce',
];
export default messageService;



// WEBPACK FOOTER //
// ./src/common/services/messageService.js